export default __webpack_public_path__ + "media/images/strawberry-dd5b441e5d866a4fb5cfd443ef1dfca0.png";